export const AppMode= {
    SPRINT : 1,
    RELAY : 2,
}